import { useLayoutEffect, type ReactNode } from "react";
import { applyDisplayPreferences } from "./bootstrap";
import type { AppLocale, ThemePreference } from "../preferences/types";
export function ThemeProvider({ locale, theme, children }: { locale: AppLocale; theme: ThemePreference; children: ReactNode }) {
  useLayoutEffect(() => applyDisplayPreferences(locale, theme), [locale, theme]);
  return <>{children}</>;
}
